import type { ReactNode } from 'react';

interface Props {
  label: string;
  value: ReactNode;
  tone?: 'default' | 'good' | 'bad' | 'warn' | 'info';
  hint?: string;
}

/**
 * Compact metric tile (label on top, large numeric value below). Matches the
 * "Files in Manifest / Found / Missing / Duplicate Sets" tiles in the Sneaky
 * Project Phase 3 mockup.
 */
export function StatTile({ label, value, tone = 'default', hint }: Props) {
  return (
    <div className={`stat-tile stat-tile-${tone}`} title={hint}>
      <div className="stat-tile-label">{label}</div>
      <div className="stat-tile-value">{value}</div>
    </div>
  );
}
